import useApiClient from './api-client'
import type { EatigoFilterFilterRes } from '@/types/api'
import type { GetFiltersReqParams } from '@/types/filters'

export const getFilter = async (params: GetFiltersReqParams) => {
  const api = useApiClient<EatigoFilterFilterRes>()
  const result = await api(`/filters`, { query: params })

  return result
}
